import React from 'react';
import { render } from 'react-dom';
import { getSprinkles } from './sprinkles';
import { getStore } from './store';
import { componentList }  from './helpers/componentList';

export const initializeReact = async () => {
    const store = await getStore();

    getSprinkles().forEach(({ componentName, componentProps, sprinkleEl }) => {
        const Component = componentList[componentName];
        if (Component) {
            render(<Component store={store} {...componentProps} />, sprinkleEl);
        }
    });
};
